import _ from 'underscore';
import xtend from 'xtend';

import Store from '../../lib/store/store-v2';

export default function (domainName, apiBus, socketBus) {

    var state = Store();

    var key;
    switch (domainName) {
        case 'categories': key = 'categoryID'; break;
        case 'keywords': key = 'keywordID'; break;
        case 'locations': key = 'locationID'; break;
        case 'technicians': key = 'techID'; break;
        case 'encoders': key = 'encoderID'; break;
        case 'assets': key = 'assetID'; break;
    }

    function resolveGetRequest (event) {

        let child;

        switch (domainName) {
            // case 'keywords':
            //     if (event.data.hasOwnProperty('clientKeywords')) {
            //         child = 'clientKeywords';
            //     }
            //     break;
            case 'locations':
                if (event.data.hasOwnProperty('clientLocations')) {
                    child = 'clientLocations';
                }
                break;
            case 'technicians':
                if (event.data.hasOwnProperty('clientTechs')) {
                    child = 'clientTechs';
                }
                break;
            default:
                break;
        }

        var data = (child) ?
            _(event.data[child]).indexBy(key) :
            _(event.data).indexBy(key);

        if (event.noParse) data = event;

        state.set({
            isResolving: false,
            data: data
        });
    }

    var apiActions = Store.ApiActions(state, key, {
        get: resolveGetRequest,
        getMiscAssets: resolveGetRequest
    });

    Store.SubscribeToApi(apiActions, apiBus);

    var socketActions = Store.WebsocketActions(state, key, {
        connect: Store.WebsocketActions.prototype.update,
        disconnected: Store.WebsocketActions.prototype.update
    });

    var allEvents = Store.WebsocketEvents.concat(['connect', 'disconnected']);
    if (socketBus) Store.SubscribeToWebsocket(allEvents, socketActions, socketBus);

    return {
        state: Store.Parse(state, function (data) {

            if(data.data.noParse) return data;

            var asArray = _.toArray(data.data);

            switch (domainName) {
                // case 'keywords': asArray = _(asArray).sortBy('keyword'); break;
                case 'locations': asArray = _(asArray).sortBy('locationName'); break;
                case 'technicians': asArray = _(asArray).sortBy('techName'); break;
            }

            return (xtend(data, { data: asArray }));
        })
    };
};
